"use client";

// src/components/tooltip-trigger-icon.tsx
import { jsx, jsxs } from "react/jsx-runtime";
function TriggerIcon(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: 16,
      height: 16,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        /* @__PURE__ */ jsx("path", { d: "M16 8A8 8 0 110 8a8 8 0 0116 0z", fill: "#FAFAFA" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8 16A8 8 0 108 0a8 8 0 000 16zM7 5a1 1 0 112 0 1 1 0 01-2 0zm1 3a1 1 0 011 1v2a1 1 0 11-2 0V9a1 1 0 011-1z",
            fill: "currentColor"
          }
        )
      ]
    }
  );
}

export {
  TriggerIcon
};
